<div class="relative z-0 h-full overflow-hidden flex flex-col flex-1">
  <div class="flex items-center justify-start border-b border-zinc-950/10 dark:border-white/10 p-2">
    <li *ngIf="selectedRoute" class="cursor-pointer p-2 hover:bg-gray-100 dark:hover:bg-white/5 border-2 border-dashed dark:border-zinc-700 rounded-lg">
      <div class="flex items-center justify-between">
        <div class="flex flex-1 items-center gap-2">
          <div
            class="inline-grid size-10 shrink-0 rounded-[--avatar-radius] align-middle outline outline-1 -outline-offset-1 outline-black/[--ring-opacity] [--avatar-radius:20%] [--ring-opacity:20%] *:rounded-[--avatar-radius] dark:outline-white/[--ring-opacity] overflow-hidden">
            <img alt="Profile Image" class="ng-star-inserted relative size-full text-gray-400 object-cover"
              src="{{selectedRoute.profileImageURL ? selectedRoute.profileImageURL : 'assets/images/company-placeholder.png'}}" />
          </div>
          <div class="flex flex-col">
            <div class="text-sm-dark font-bold leading-tight">{{selectedRoute.name ? (selectedRoute.name | titlecase) :
              (selectedRoute.title | titlecase)}}
            </div>
            <div class="text-sm-light leading-tight">{{selectedRoute.phoneNumber}}</div>
          </div>
        </div>
        <div>
          <!-- <span class="badge-success">{{item.isActive ? "Active":'Inactive'}}</span> -->
          <!-- <span *ngFor="let item of item.serviceAreas" class="badge-success">{{preServiceAreas[item].title}}</span> -->
        </div>
      </div>
    </li>
  </div>
  <div class="h-full flex flex-col gap-2 z-0 relative p-2 lg:pl-0 overflow-hidden">
    <form class="grid grid-cols-1 md:grid-cols-4 gap-3 h-full  overflow-hidden relative z-0" [formGroup]="fareForm"
      (ngSubmit)="onSave()">
      <!-- Sidebar -->
      <div
        class="col-span-1 sticky overflow-y-auto max-h-screen p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
        <ul class="space-y-1">


          <div class="relative">
            <input [(ngModel)]="search" type="text" placeholder="Search.." [ngModelOptions]="{standalone: true}"
              class="pl-8 ">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z">
              </path>
            </svg>
          </div>

          <div *ngIf="submitted && !selectedSpaceType">
            <small class="pt-1 text-red-600 text-xs">
              Space Type is required
            </small>
          </div>

          <li *ngFor="let spacetype of spacetypes | filter : search"
            class="cursor-pointer flex items-center gap-4 p-2 rounded-lg border border-zinc-950/10 dark:border-white/10 text-sm-dark"
            [ngClass]="{
                'bg-zinc-400 dark:bg-zinc-700 text-zinc-900 dark:text-white dark:border-zinc-600': spacetype.id === selectedSpaceType?.id,
                'bg-zinc-950/5 dark:bg-white/5': spacetype.id !== selectedSpaceType?.id
              }" (click)="selectSpaceType(spacetype)">
            <span class="text-sm-dark">{{spacetype.title | uppercase}}
              <span *ngIf="spacetype.los" class="text-xs text-primary dark:text-primary">
                (LOS: {{ (prelevelOfServices && prelevelOfServices[spacetype.los]) ? (prelevelOfServices[spacetype.los].title | uppercase) : 'N/A' }})
              </span>
            </span>
          </li>


        </ul>
      </div>
      <!-- Form -->
      <div class="flex flex-col col-span-3 gap-3 h-full overflow-y-auto">
        <!-- Main Form -->
        <div
          class="col-span-3 p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
          <div *ngIf="companyId" class="flex justify-end">
            <div class="flex justify-end">
              <div class="bg-gray-100 dark:bg-zinc-900 p-1 rounded-xl flex shadow-sm">
                <!-- Normal Tab -->
                <button type="button" (click)="form.type.setValue('fixed')" [ngClass]="form.type.value === 'fixed'
                    ? 'bg-white text-gray-900 shadow dark:bg-gray-800 dark:text-white'
                    : 'text-gray-500 hover:text-gray-900 dark:hover:text-gray-300'"
                  class="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200">
                  Fixed
                </button>

                <!-- Percentage Tab -->
                <button type="button" (click)="form.type.setValue('percentage')" [ngClass]="form.type.value === 'percentage'
                    ? 'bg-white text-gray-900 shadow dark:bg-gray-800 dark:text-white'
                    : 'text-gray-500 hover:text-gray-900 dark:hover:text-gray-300'"
                  class="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200">
                  Percentage
                </button>
              </div>
            </div>

          </div>

          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">

            <div class="sm:col-span-2 ">
              <label for="name" class="text-sm-dark mb-1">
                Name <span class="text-red-600">*</span>
              </label>
              <div class="flex items-center">
                <input type="text" name="name" id="name" class="" formControlName="name" />
              </div>
              <div *ngIf="submitted && form.name.errors">
                <div *ngIf="form.name.errors.required" class="pt-1 text-red-600 text-xs">
                  Name is required
                </div>
              </div>
            </div>
            <!-- Start Time -->
            <div class="sm:col-span-2 ">
              <label for="name" class="text-sm-dark mb-1">
                Start Time <span class="text-red-600">*</span>
              </label>
              <div class="flex items-center">
                <input type="text" name="time" id="time" class="" formControlName="startTime" [owlDateTime]="startTime"
                  [owlDateTimeTrigger]="startTime" [min]="getTimeRestrictions().min" [max]="form.endTime.value" [readOnly]="true" />
                <owl-date-time [pickerType]="'timer'" (afterPickerClosed)="onDateChange(form.startTime)"
                  #startTime></owl-date-time>

                <!-- <span
                            class="rounded-r-lg px-[calc(theme(spacing.3)-1px)] py-[calc(theme(spacing[2])-1px)] text-sm border-y border-r border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark">$</span> -->
              </div>
              <div *ngIf="submitted && form.startTime.errors">
                <div *ngIf="form.startTime.errors.required" class="pt-1 text-red-600 text-xs">
                  Start Time is required
                </div>
              </div>
            </div>

            <!-- End Time -->
            <div class="sm:col-span-2">
              <label for="name" class="text-sm-dark mb-1">
                End Time <span class="text-red-600">*</span>
              </label>
              <div class="flex items-center">
                <input type="text" name="time" class="" id="time" formControlName="endTime" [owlDateTime]="endTime"
                  [min]="form.startTime.value" [max]="getTimeRestrictions().max" [owlDateTimeTrigger]="endTime" [readOnly]="true" />
                <owl-date-time [pickerType]="'timer'" (afterPickerClosed)="onDateChange(form.endTime)"
                  #endTime></owl-date-time>
                <!-- <span
                            class="rounded-r-lg px-[calc(theme(spacing.3)-1px)] py-[calc(theme(spacing[2])-1px)] text-sm border-y border-r border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark">Mile</span> -->
              </div>
              <div *ngIf="submitted && form.endTime.errors">
                <div *ngIf="form.endTime.errors.required" class="pt-1 text-red-600 text-xs">
                  End Time is required
                </div>
              </div>
            </div>

            <!-- Days -->
            <div class="sm:col-span-2">
              <label for="name" class="text-sm-dark mb-1">
                Days <span class="text-red-600">*</span>
              </label>
              <div>
                <ng-select [ngModelOptions]="{standalone: true}" [items]="days" bindLabel="label" bindValue="day"
                  [(ngModel)]="selectedDays" [multiple]="true" [clearable]="false" [closeOnSelect]="false"
                  placeholder="Select Days" [searchable]="true">
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    <input type="checkbox" id="day-{{ index }}" [checked]="selectedDays?.includes(item.day)" />
                    {{ (item.label | titlecase) }}
                  </ng-template>
                </ng-select>
              </div>

              <div *ngIf="submitted && !selectedDays.length">
                <p *ngIf="form.days?.errors?.required" class="pt-1 text-red-600 text-xs">
                  Days are required
                </p>
              </div>
            </div>

            <!-- Base Rate group -->
            <ng-container formGroupName="baseFare">
              <!-- Rate  -->
              <div class="sm:col-span-2">
                <label for="name" class="text-sm-dark mb-1">
                  Base Rate <span class="text-red-600">*</span>
                </label>
                <div class="flex items-center">
                  <input type="text" formControlName="fare" class="rounded-r-none " name="name" id="name" />
                  <span *ngIf="form.type.value === 'fixed'"
                    class="rounded-r-lg px-[calc(theme(spacing.3)-1px)] py-[calc(theme(spacing[2])-1px)] text-sm border-y border-r border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark">$</span>
                  <span *ngIf="form.type.value === 'percentage'"
                    class="rounded-r-lg px-[calc(theme(spacing.3)-1px)] py-[calc(theme(spacing[2])-1px)] text-sm border-y border-r border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark">%</span>
                </div>

                <div *ngIf="submitted && baseFareFrom.get('fare')?.errors">
                  <p *ngIf="baseFareFrom.get('fare')?.errors?.required" class="pt-1 text-red-600 text-xs">
                    Base Rate is required
                  </p>
                </div>



              </div>

              <!-- For -->
              <div *ngIf="fareForm.get('type')?.value === 'fixed'" class="sm:col-span-2">
                <label for="name" class="text-sm-dark mb-1">
                  For <span class="text-red-600">*</span>
                </label>
                <div class="flex items-center">
                  <input type="text" formControlName="for" class="rounded-r-none " name="name" id="name" />
                  <span
                    class="rounded-r-lg px-[calc(theme(spacing.3)-1px)] py-[calc(theme(spacing[2])-1px)] text-sm border-y border-r border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark">Mile</span>
                </div>

                <div *ngIf="submitted && baseFareFrom.get('for')?.errors">
                  <p *ngIf="baseFareFrom.get('for')?.errors?.required" class="pt-1 text-red-600 text-xs">
                    For is required
                  </p>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="fareForm.get('type')?.value === 'fixed'">
              <!-- perMile -->
              <div class="sm:col-span-3">
                <label for="name" class="text-sm-dark mb-1">
                  Per Mile <span class="text-red-600">*</span>
                </label>
                <div class="flex items-center">
                  <input type="text" formControlName="perMile" class="rounded-r-none " name="name" id="name" />
                  <span
                    class="rounded-r-lg px-[calc(theme(spacing.3)-1px)] py-[calc(theme(spacing[2])-1px)] text-sm border-y border-r border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark">$</span>
                </div>

                <div *ngIf="submitted && form.perMile.errors">
                  <p *ngIf="form.perMile?.errors?.required" class="pt-1 text-red-600 text-xs">
                    Per Mile Rate is required
                  </p>
                </div>
              </div>

              <!-- perMin -->
              <div class="sm:col-span-3">
                <label for="name" class="text-sm-dark mb-1">
                  Per Minute <span class="text-red-600">*</span>
                </label>
                <div class="flex items-center">
                  <input type="text" formControlName="perMin" class="rounded-r-none " name="name" id="name" />
                  <span
                    class="rounded-r-lg px-[calc(theme(spacing.3)-1px)] py-[calc(theme(spacing[2])-1px)] text-sm border-y border-r border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark">$</span>
                </div>

                <div *ngIf="submitted && form.perMin.errors">
                  <p *ngIf="form.perMin?.errors?.required" class="pt-1 text-red-600 text-xs">
                    Per Minute Rate is required
                  </p>
                </div>
              </div>

              <ng-container formGroupName="waitTime">
                <!-- waitTime  fare-->
                <div class="sm:col-span-2">
                  <label for="name" class="text-sm-dark mb-1">
                    Wait Time <span class="text-red-600">*</span>
                  </label>
                  <div class="flex items-center">
                    <input type="text" formControlName="fare" class="rounded-r-none " name="name" id="name" />
                    <span
                      class="rounded-r-lg px-[calc(theme(spacing.3)-1px)] py-[calc(theme(spacing[2])-1px)] text-sm border-y border-r border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark">$</span>
                  </div>

                  <div *ngIf="submitted && waitForm.get('fare')?.errors">
                    <p *ngIf="waitForm.get('fare')?.errors?.required" class="pt-1 text-red-600 text-xs">
                      Wait Time Rate is required
                    </p>
                  </div>

                </div>

                <!-- per -->
                <div class="sm:col-span-2">
                  <label for="name" class="text-sm-dark mb-1">
                    Every <span class="text-red-600">*</span>
                  </label>
                  <div class="flex items-center">
                    <input type="text" formControlName="per" class="rounded-r-none " name="name" id="name" />
                    <span
                      class="rounded-r-lg px-[calc(theme(spacing.3)-1px)] py-[calc(theme(spacing[2])-1px)] text-sm border-y border-r border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark">Minutes</span>
                  </div>

                  <div *ngIf="submitted && waitForm.get('per')?.errors">
                    <p *ngIf="waitForm.get('per')?.errors?.required" class="pt-1 text-red-600 text-xs">
                      Every 'X' minute(s) interval is required
                    </p>
                  </div>

                </div>

                <!-- after -->
                <div class="sm:col-span-2">
                  <label for="name" class="text-sm-dark mb-1">
                    Free Quota <span class="text-red-600">*</span>
                  </label>
                  <div class="flex items-center">
                    <input type="text" formControlName="after" class="rounded-r-none " name="name" id="name" />
                    <span
                      class="rounded-r-lg px-[calc(theme(spacing.3)-1px)] py-[calc(theme(spacing[2])-1px)] text-sm border-y border-r border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark">Minutes</span>
                  </div>

                  <div *ngIf="submitted && waitForm.get('after')?.errors">
                    <p *ngIf="waitForm.get('after')?.errors?.required" class="pt-1 text-red-600 text-xs">
                      Free Quota is required
                    </p>
                  </div>
                </div>
              </ng-container>
            </ng-container>

          </div>
        </div>
        <!-- Cancel Charges -->
        <div class="p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">

          <ng-container formGroupName="cancelCharges">
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">

              <!-- cancelCharges -->
              <div class="sm:col-span-3">
                <label for="name" class="text-sm-dark mb-1">
                  Cancel Charges <span class="text-red-600">*</span>
                </label>
                <div class="flex items-center">
                  <input type="text" formControlName="value" class="rounded-r-none " name="name" id="name" />
                  <span *ngIf="cancelChargesForm.get('type')?.value === 'fixed'"
                    class="rounded-r-lg px-[calc(theme(spacing.3)-1px)] py-[calc(theme(spacing[2])-1px)] text-sm border-y border-r border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark">$</span>
                  <span *ngIf="cancelChargesForm.get('type')?.value === 'percentage'"
                    class="rounded-r-lg px-[calc(theme(spacing.3)-1px)] py-[calc(theme(spacing[2])-1px)] text-sm border-y border-r border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark">%</span>
                </div>

                <div *ngIf="submitted && cancelChargesForm.get('value')?.errors">
                  <p *ngIf="cancelChargesForm.get('value')?.errors?.required" class="pt-1 text-red-600 text-xs">
                    Cancel Charges are required
                  </p>
                </div>

              </div>
              <div *ngIf="form.type.value === 'percentage' && companyId" class="sm:col-span-3">
                <div class="flex justify-end items-center">
                  <div class="bg-gray-100 dark:bg-zinc-900 p-1 rounded-xl flex shadow-sm">
                    <!-- Normal Tab -->
                    <button type="button" (click)="cancelChargesForm.get('type')?.setValue('fixed')" [ngClass]="cancelChargesForm.get('type')?.value === 'fixed'
                                   ? 'bg-white text-gray-900 shadow dark:bg-gray-800 dark:text-white'
                    : 'text-gray-500 hover:text-gray-900 dark:hover:text-gray-300'"
                      class="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200">
                      Fixed
                    </button>

                    <!-- Percentage Tab -->
                    <button type="button" (click)="cancelChargesForm.get('type')?.setValue('percentage')" [ngClass]="cancelChargesForm.get('type')?.value === 'percentage'
                                  ? 'bg-white text-gray-900 shadow dark:bg-gray-800 dark:text-white'
                    : 'text-gray-500 hover:text-gray-900 dark:hover:text-gray-300'"
                      class="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200">
                      Percentage
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </ng-container>
        </div>
        <!-- No Show Charges -->
        <div class="p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
          <ng-container formGroupName="noShowCharges">

            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <!-- noShowCharges -->
              <div class="sm:col-span-3">
                <label for="name" class="text-sm-dark mb-1">
                  No Show Charges <span class="text-red-600">*</span>
                </label>
                <div class="flex items-center">
                  <input type="text" formControlName="value" class="rounded-r-none " name="name" id="name" />
                  <span *ngIf="noShowChargesForm.get('type')?.value === 'fixed'"
                    class="rounded-r-lg px-[calc(theme(spacing.3)-1px)] py-[calc(theme(spacing[2])-1px)] text-sm border-y border-r border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark">$</span>
                  <span *ngIf="noShowChargesForm.get('type')?.value === 'percentage'"
                    class="rounded-r-lg px-[calc(theme(spacing.3)-1px)] py-[calc(theme(spacing[2])-1px)] text-sm border-y border-r border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark">%</span>
                </div>

                <div *ngIf="submitted && noShowChargesForm.get('value')?.errors">
                  <p *ngIf="noShowChargesForm.get('value')?.errors?.required" class="pt-1 text-red-600 text-xs">
                    No Show Charges are required
                  </p>
                </div>
              </div>
              <div *ngIf="form.type.value === 'percentage' && companyId" class="sm:col-span-3">
                <div class="flex justify-end items-center">
                  <div class="bg-gray-100 dark:bg-zinc-900 p-1 rounded-xl flex shadow-sm">
                    <!-- Normal Tab -->
                    <button type="button" (click)="noShowChargesForm.get('type')?.setValue('fixed')" [ngClass]="noShowChargesForm.get('type')?.value === 'fixed'
                                                              ? 'bg-white text-gray-900 shadow dark:bg-gray-800 dark:text-white'
                    : 'text-gray-500 hover:text-gray-900 dark:hover:text-gray-300'"
                      class="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200">
                      Fixed
                    </button>

                    <!-- Percentage Tab -->
                    <button type="button" (click)="noShowChargesForm.get('type')?.setValue('percentage')" [ngClass]="noShowChargesForm.get('type')?.value === 'percentage'
                                                              ? 'bg-white text-gray-900 shadow dark:bg-gray-800 dark:text-white'
                    : 'text-gray-500 hover:text-gray-900 dark:hover:text-gray-300'"
                      class="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200">
                      Percentage
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </ng-container>
        </div>
        <!-- Zones -->
        <div
          class="col-span-full p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
          <ng-container>
            <!-- Header with Label Left & Toggle Right -->
            <div class="flex justify-between items-center mb-4">
              <h3 class="text-lg font-medium leading-6 text-main-dark">Zones</h3>

              <div class="sm:col-span-2 flex items-center justify-center border border-dashed border-zinc-950/10 dark:border-white/10 p-1.5 rounded-lg gap-2.5">
                <label for="label" class="text-sm-dark">Calculate Zone Per Mile</label>
                <label
                  class="relative inline-flex h-6 w-12 flex-shrink-0 cursor-pointer rounded-full border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                  <input type="checkbox" formControlName="isPerMileZone" class="peer sr-only"
                    (change)="onToggleZonePerMile($event)" aria-checked="fareForm.get('isPerMileZone')?.value" />
                  <span
                    class="pointer-events-none relative inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition-all duration-200 ease-in-out peer-checked:translate-x-6 peer-checked:bg-green-500">
                    <span *ngIf="!fareForm.value.isPerMileZone"
                      class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-0"
                      aria-hidden="true">
                      <svg class="h-3 w-3 text-red-500" fill="none" viewBox="0 0 12 12">
                        <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </span>
                    <span *ngIf="fareForm.value.isPerMileZone"
                      class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-100"
                      aria-hidden="true">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="h-3 w-3 text-white">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                      </svg>
                    </span>
                  </span>
                </label>
              </div>
            </div>

            <!-- Zones -->
            <div formArrayName="zones">
              <div *ngFor="let zone of zonesFormArray.controls; let i = index" [formGroupName]="i"
                class="mt-2 bg-white dark:bg-zinc-900 border-2 border-dashed border-main-base p-4 rounded-lg">

                <!-- Zone Title -->
                <h4 class="text-md font-medium leading-6 text-main-secondary mb-2">Zone {{ i + 1 }}</h4>
                <div class="border-b border-main-base mb-3"></div>

                <div class="grid grid-cols-1 sm:grid-cols-6 gap-4">

                  <!-- Base Fare -->
                  <div class="sm:col-span-2">

                    <label class="block text-sm font-medium text-main-secondary">Base Fare  <span class="text-red-600">*</span></label>
                    <div class="flex items-center p-1">
                      <input type="text" formControlName="baseFare" class="rounded-r-none " name="name" id="name" />
                      <span *ngIf="form.type.value === 'fixed'"
                        class="rounded-r-lg px-[calc(theme(spacing.3)-1px)] py-[calc(theme(spacing[2])-1px)] text-sm border-y border-r border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark">$</span>
                      <span *ngIf="form.type.value === 'percentage'"
                        class="rounded-r-lg px-[calc(theme(spacing.3)-1px)] py-[calc(theme(spacing[2])-1px)] text-sm border-y border-r border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark">%</span>
                    </div>
                    <div *ngIf="zone.get('baseFare')?.errors && submitted">
                      <p class="text-red-600 text-xs">Base Fare is required</p>
                    </div>
                  </div>


                  <!-- Fare / Per Mile -->
                  <div *ngIf="fareForm.get('type')?.value === 'fixed'" class="sm:col-span-2">
                    <label class="block text-sm font-medium text-main-secondary">
                      {{ fareForm.value.isPerMileZone ? 'Per Mile' : 'Fare' }}  <span class="text-red-600">*</span>
                    </label>
                    <input type="text" formControlName="fare" class="mt-1 w-full" />
                    <div *ngIf="zone.get('fare')?.errors && submitted">
                      <p class="text-red-600 text-xs">
                        {{ fareForm.value.isPerMileZone ? 'Per Mile' : 'Fare' }} is required
                      </p>
                    </div>
                  </div>


                  <!-- From -->
                  <div class="sm:col-span-2">
                    <label class="block text-sm font-medium text-main-secondary">From  <span class="text-red-600">*</span></label>
                    <input type="text" formControlName="from" class="mt-1 w-full" />
                    <div *ngIf="zone.get('from')?.errors && submitted">
                      <p class="text-red-600 text-xs">From is required</p>
                    </div>
                  </div>

                  <!-- To -->
                  <div class="sm:col-span-2">
                    <label class="block text-sm font-medium text-main-secondary">To  <span class="text-red-600">*</span></label>
                    <input type="text" formControlName="to" class="mt-1 w-full" />
                    <div *ngIf="zone.get('to')?.errors && submitted">
                      <p class="text-red-600 text-xs">To is required</p>
                    </div>
                  </div>

                  <!-- Remove Button -->
                  <div class="sm:col-span-1 flex items-end">
                    <button type="button"
                      class="bg-red-500 text-white rounded-lg px-3 py-2 text-sm shadow hover:bg-red-600 transition"
                      (click)="removeZone(i)">Remove</button>
                  </div>
                </div>
              </div>

              <!-- Add Zone Button -->
              <div class="mt-4">
                <button type="button" class="btn btn-secondary" (click)="addZone()">+ Add Zone</button>
              </div>
            </div>

          </ng-container>
        </div>

        <!-- Per mile Charges -->
        <div class="p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">


          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <!-- perMileCode -->
            <div class="sm:col-span-3">
              <label for="name" class="text-sm-dark mb-1">
                Per Mile Code
              </label>
              <div class="flex items-center">
                <input type="text" formControlName="perMileCode" class="rounded-r-lg " name="name" id="name" />
              </div>
            </div>

            <!-- Dry Run Code -->
            <div class="sm:col-span-3">
              <label for="name" class="text-sm-dark mb-1">
                Dry Run Code
              </label>
              <div class="flex items-center">
                <input type="text" formControlName="dryRunCode" class="rounded-r-lg " name="name" id="name" />
              </div>
            </div>

            <!-- baseFareCode -->
            <div class="sm:col-span-3">
              <label for="name" class="text-sm-dark mb-1">
                Base Rate Code
              </label>
              <div class="flex items-center">
                <input type="text" formControlName="baseFareCode" class="rounded-r-lg " name="name" id="name" />
              </div>
            </div>

            <!-- waitTimeCode -->
            <div class="sm:col-span-3">
              <label for="name" class="text-sm-dark mb-1">
                Wait time Code
              </label>
              <div class="flex items-center">
                <input type="text" formControlName="waitTimeCode" class="rounded-r-lg " name="name" id="name" />
              </div>
            </div>

            <!-- Weekeend Night Code -->
            <div class="sm:col-span-3">
              <label for="name" class="text-sm-dark mb-1">
                Weekend Night Code
              </label>
              <div class="flex items-center">
                <input type="text" formControlName="weekendNightCode" class="rounded-r-lg " name="name" id="name" />
              </div>
            </div>

            <!-- formControlName="" -->
            <div class="sm:col-span-3">
              <label for="name" class="text-sm-dark mb-1">
                Response Night Code
              </label>
              <div class="flex items-center">
                <input type="text" formControlName="nightCode" class="rounded-r-lg " name="name" id="name" />
              </div>
            </div>
            <div class="sm:col-span-2">
              <label for="name" class="text-sm-dark mb-1">
                Status
              </label>
              <div>
                <div>
                  <select formControlName="isActive">
                    <option [ngValue]="true">Active</option>
                    <option [ngValue]="false">Inactive</option>
                  </select>
                </div>
                <div *ngIf="submitted && form.isActive.errors">
                  <p *ngIf="form.isActive.errors.required" class="pt-1 text-red-600 text-xs">
                    Status is required
                  </p>
                </div>


              </div>
            </div>

            <!-- <div class="sm:col-span-3">
                                            <label for="name" class="text-sm-dark mb-1">
                                              Per Minute
                                            </label>
                                            <div class="flex items-center">
                                              <input type="text" formControlName="" class="rounded-r-none " name="name" id="name" />
                                              <span
                                                class="rounded-r-lg px-[calc(theme(spacing.3)-1px)] py-[calc(theme(spacing[2])-1px)] text-sm border-y border-r border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark">$</span>
                                            </div>
                                          </div> -->
          </div>
          <div class="flex justify-end mt-2">
            <button type="submit" class="btn btn-secondary">
              {{fareId ? 'Update' : 'Create'}}
            </button>
          </div>


        </div>
      </div>

    </form>
  </div>
</div>